import { render, staticRenderFns } from "./domandaLezione.vue?vue&type=template&id=88bff618&scoped=true&"
import script from "./domandaLezione.vue?vue&type=script&lang=ts&"
export * from "./domandaLezione.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bff618",
  null
  
)

export default component.exports